import { Client } from "openapi-fetch";
import { createContext } from "react";
import type { paths } from "../lib/api/v1";

type ApiContextState = Client<paths>;

export const ApiContext = createContext<ApiContextState | null>(null);
